// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Header----header-module---container---QFptZ","content":"src-components-Header----header-module---content---3Ur3P","heading":"src-components-Header----header-module---heading---3QK0y","subheading":"src-components-Header----header-module---subheading---327vY","icon":"src-components-Header----header-module---icon---3SmgZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/header.module.scss
// module id = 261
// module chunks = 35783957827783